<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Alarms from './alarms'

import axios from 'axios'

export default {
	page: {
		title: 'All Office 365 Alarms',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Alarms },
	data() {
		return {
			title: 'All Office 365 Alarms',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Alarms',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Alarms :url="'/office365/alarms/list?'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
